export default {
  cake: {
    56: '0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
    97: '0xEbD1868E3c49b8eEfc0418d5Ca4dE1022b899d60',
  },
  masterChef: {
    56: '0xe70E9185F5ea7Ba3C5d63705784D8563017f2E57',
    97: '0x0Aa59aF054f60078B56051D52594f0785b0501dA',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7',
  },
  // delegate farm kontratları
  delegate : {
    56 : '0xaf0400156c48672c5eec011114209fe05e3e7c28',
    97 : '0xFC3F8e9AbADbB74Edf785a979A23a83679D0598D',
  },
}
  
